<template>
    <div class="daily_task">
        <div class="daily_task_header">
            <div class="left_title">精选任务</div>
            <div class="right_content" @click="showTaskList">
                <div class="right_desc">更多任务</div>
                <img :src="iconArrowRight" alt="" />
            </div>
        </div>
        <div class="tasks">
            <task-row
                v-for="(items, index) in daysTaskData"
                :key="index"
                :task="items"
                class="margin_top"
                @Oncellclick="cellClick"
            />
        </div>
    </div>
</template>

<script>
import iconScore from '@/assets/img/icon-score.png';
import iconArrowRight from '@/assets/iconV2.5/mygrade-arrow@2x.png';
import taskRow from './taskRow.vue';
import homemixin from '@common/js/mixin';
// import mock from './mock.json';
export default {
    name: 'DailyTask',
    components: {
        taskRow
    },
    mixins: [homemixin],
    props: ['daysTaskData', 'scoreInfoData', 'switch3DCat'],
    data() {
        return {
            iconScore,
            iconArrowRight
        };
    },
    watch: {
        daysTaskData: {
            deep: true,
            immediate: true,
            handler: function(newV) {
                if (newV && newV.length > 0) {
                    newV.forEach(item => {
                        this.POINT('h5_element_imp', {
                            page: 'super-成长权益页',
                            tgt_event_id: 'h5_ACT_privilege_tasklist',
                            tgt_name: 'h5-ACT-成长权益-任务栏',
                            param: this.scoreInfoData.totalScore,
                            param1: this.scoreInfoData.allScore,
                            param2: item.title,
                            param3: item.afterRewardScore,
                            param4: item.taskButtonText,
                            param5: item.desc,
                            param6: item.score,
                            param7: item.afterRewardScore - item.score,
                            param8: '',
                            param9: item.taskId,
                            param10: this.switch3DCat ? '是' : '否'
                        });
                    });
                }
            }
        }
    },
    methods: {
        showTaskList() {
            this.$emit('OnShowTaskList', 'dailyTask');
        },
        async cellClick(taskItem) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-任务栏',
                tgt_event_id: 'h5_ACT_privilege_tasklist',
                param: this.scoreInfoData.totalScore,
                param1: this.scoreInfoData.allScore,
                param2: taskItem.title,
                param3: taskItem.afterRewardScore,
                param4: taskItem.taskButtonText,
                param5: taskItem.desc,
                param6: taskItem.score,
                param7: taskItem.afterRewardScore - taskItem.score,
                param8: '',
                param9: taskItem.taskId,
                param10: this.switch3DCat ? '是' : '否'
            });
            if (taskItem.taskStatus === 0 && taskItem.taskHandler === 'LLHDongTaskHandler') {
                const { Result } = await this.$http.notifyLLHDongTaskDone({
                    taskId: taskItem.taskId
                });
                if (Result === 200) {
                    if (taskItem.redirectUrl) {
                        this.openLink(taskItem.redirectUrl);
                    }
                }
            } else if (taskItem.taskId > 804 && taskItem.taskId < 812) {
                // 房贷申请:805 房贷成交:806 车贷申请: 807  车贷签约:808  车贷成交: 809  试算线索:811
                if (taskItem.taskStatus === 0) {
                    const { Result } = await this.$http.taskReceive({
                        taskId: taskItem.taskId
                    });
                    if (Result === 200) {
                        if (taskItem.redirectUrl) {
                            this.openLink(taskItem.redirectUrl);
                        }
                    }
                } else {
                    if (taskItem.redirectUrl) {
                        if (taskItem.taskStatus === 3 && taskItem.taskId === 811) {
                            return;
                        }
                        this.openLink(taskItem.redirectUrl);
                    }
                }
            } else {
                if (taskItem.redirectUrl) {
                    if (taskItem.taskStatus === 0) {
                        this.openLink(taskItem.redirectUrl);
                    }
                    if (
                        taskItem.taskStatus === 3 &&
                        [101, 204, 618, 619].indexOf(taskItem.taskId) > -1
                    ) {
                        // 借款任务：101，视频浏览任务：204，团险浏览任务：618，浏览法人报告：619， 认证中或已完成可以继续浏览
                        this.openLink(taskItem.redirectUrl);
                    }
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
.daily_task {
    width: 375px;
    overflow: hidden;
    position: relative;
    margin-top: 24px;
    .daily_task_header {
        height: 38px;
    }

    .left_title {
        width: 160px;
        font-size: 18px;
        font-weight: bold;
        color: #002a3c;
        position: absolute;
        left: 18px;
        line-height: 22px;
    }

    .right_content {
        width: 91px;
        height: 15px;
        position: absolute;
        right: 0;
    }

    .right_desc {
        font-size: 13px;
        color: #254d5e;
        position: absolute;
        white-space: nowrap;
        top: 2px;
        right: 30px;
        line-height: 18px;
    }

    img {
        width: 6px;
        height: 10px;
        position: absolute;
        top: 5px;
        right: 17px;
    }

    .margin_top {
        margin-top: 32px;
        &:first-child {
            margin-top: 0;
        }
    }
}
</style>
